export default class {
	constructor($state) {
        'ngInject';
        
        this._$state = $state;
        
		return {
			STATUS: {
				ADD: 0,
				UPDATE: 1,
				DELETE: 2,
				STATIC: -1
            },
            FEATURE: {
				ADMISSION: 'ADMISSIONS',
				PROGRAM: 'PROGRAMS',
				ABOUT: 'ABOUT',
				STUDENT: 'STUDENTS',
				TEACHER: 'TEACHERS',
				CONTACT: 'CONTACT',
				DONATION: 'DONATION',
				CATEGORY: 'PROGRAMS',
				FEE: 'PROGRAMS',
				CLASSES: 'CLASSES',
				EVENTS: 'EVENTS',
				HOLIDAYS: 'HOLIDAYS',
				SUBJECTS: 'SUBJECTS',
				POSITIONS: 'POSITIONS',
				PHOTOGALLERY: 'PHOTOGALLERY',
				NEWSLETTER: 'NEWSLETTER',
				BANNERS: 'BANNERS',
				LEGALDOCUMENTS: 'LEGALDOCUMENTS',
				PUSHNOTIFICATION: 'PUSHNOTIFICATION',
				MEALCALENDAR: 'MEALCALENDAR',
				PARENTS: 'PARENTS',
				LOCATION: 'LOCATION',
				ATTENDANCE: 'ATTENDANCE',
				FAQ: 'FAQ',
				PROGRESSREPORT: 'PROGRESSREPORT',
				FORM: 'FORM',
				CAREER: 'CAREER',
				STAFF: 'STAFF',
				ACTIVITYLOG: 'ACTIVITYLOG'
			},
			ACCESS: {
				VIEW: 'VIEW',
				ADD: 'ADD',
				EDIT: 'EDIT',
				DELETE: 'DELETE'
			},
            EVENT:{
                EVENT_DURATION:{
                    SINGLE_DAY:1,
                    MULTIPLE_DAY:2
                }
            },

            YEAR:{
                YEAR_QUARTER:{
                    FIRST_QUARTER: 1,
                    SECOND_QUARTER: 2,
                    THIRD_QUARTER: 3,
                    FOURTH_QUARTER:4
                },
                MONTH_LIST:{
                    JAN:0,
                    FEB:1,
                    MAR:2,
                    APR:3,
                    MAY:4,
                    JUN:5,
                    JUL:6,
                    AUG:7,
                    SEP:8,
                    OCT:9,
                    NOV:10,
                    DEC:11
                }
            },

            RESOURCE:{
                CATEGORY_OPTION:{
                    WEB_LINK: 1,
                    ATTACHMENT: 2
                }
            },
            USER: {
                TYPE: {
                    FOSTER_YOUTH: 1,
                    FOSTER_PARENT: 2,
                    SOCIAL_WORKER: 3
                }
            }
		}
	}
};

export const key = '58ea9de3084dee47dcd5beb86343be4242097d503b7b29ea7884cd84a0d73578'


// WEBPACK FOOTER //
// ./src/app/Constants.js